// Хуки для работы с NSI v20_tfoms_style
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import * as nsiTfomsApi from '@/api/nsiTfoms'

export const useV20TfomsStyle = () => {
  return useQuery({
    queryKey: ['v20-tfoms-style'],
    queryFn: nsiTfomsApi.fetchV20TfomsStyle,
  })
}

export const useCreateV20TfomsRecord = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: nsiTfomsApi.createV20TfomsRecord,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['v20-tfoms-style'] })
      message.success('Запись создана')
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.detail || 'Ошибка при создании записи')
    },
  })
}

export const useUpdateV20TfomsRecord = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ idpk_tfoms, data }: { idpk_tfoms: number; data: nsiTfomsApi.V20TfomsStyleUpdate }) =>
      nsiTfomsApi.updateV20TfomsRecord(idpk_tfoms, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['v20-tfoms-style'] })
      message.success('Запись обновлена')
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.detail || 'Ошибка при обновлении записи')
    },
  })
}

export const useDeleteV20TfomsRecord = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (idpk_tfoms: number) => nsiTfomsApi.deleteV20TfomsRecord(idpk_tfoms),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['v20-tfoms-style'] })
      message.success('Запись удалена')
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.detail || 'Ошибка при удалении записи')
    },
  })
}
